import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FinanceiroService } from '../../../../services/financeiro.service';
import { TipoContaEnum } from '../../../../../../core/enums/tipo-conta.enum';
import { NovaConta } from '../../../models/nova-conta';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../auth/services/auth-service';
import { BaixarConta } from '../../../models/baixar-conta';

@Component({
  selector: 'app-financeiro-contas-receber',
  templateUrl: './financeiro-contas-receber.component.html',
  styleUrls: ['./financeiro-contas-receber.component.css'],
  standalone: false
})
export class FinanceiroContasReceberComponent implements OnInit {
  @Input() pessoas: any = { itens: [] };

  contasAReceber: any[] = [];

  contasReceberAgrupadas: any[] = [];
  modalNovaConta = false;
  modalReceberConta = false;
  modalDeletarConta = false;

  novaConta: NovaConta = {
    descricao: '',
    valor: 0,
    dataVencimento: '',
    tipoConta: TipoContaEnum.ContaAReceber,
    categoria: 0
  };

  recebimento: any = {
    dataPagamento: '',
    valor: 0,
    conta: null
  };

  contaParaDeletar: any = null;

  constructor(
    private financeiroService: FinanceiroService,
    private toastr: ToastrService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.carregarContas();
  }

  carregarContas() {
    this.financeiroService.obterContasAReceber().subscribe(response => {
      if (response.sucesso && Array.isArray(response.dados)) {
        this.contasAReceber = response.dados;
        this.agruparContas();
      }
    });
  }

  agruparContas() {
    this.contasReceberAgrupadas = this.processarAgrupamento(this.contasAReceber);
  }

  processarAgrupamento(contas: any[]) {
    const meses = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    const agrupado = contas.reduce((acc, conta) => {
      const data = new Date(conta.dataVencimento);
      const mesNome = meses[data.getMonth()] + ' ' + data.getFullYear();

      if (!acc[mesNome]) {
        acc[mesNome] = { mes: mesNome, total: 0, contas: [], mesIndex: data.getMonth(), ano: data.getFullYear() };
      }

      acc[mesNome].contas.push(conta);
      acc[mesNome].total += conta.valor;
      return acc;
    }, {});

    return Object.values(agrupado).sort((a: any, b: any) => {
      if (a.ano !== b.ano) return a.ano - b.ano;
      return a.mesIndex - b.mesIndex;
    });
  }

  abrirModalNovaConta() {
    this.novaConta = {
      descricao: '',
      valor: 0,
      dataVencimento: '',
      tipoConta: TipoContaEnum.ContaAReceber,
      categoria: 0
    };
    this.modalNovaConta = true;
  }

  fecharModal() {
    this.modalNovaConta = false;
    this.modalReceberConta = false;
    this.modalDeletarConta = false;
  }

  salvarConta() {
    if (this.novaConta.id) {
      this.financeiroService.alterarConta(this.novaConta).subscribe(response => {
        if (response.sucesso) {
          this.toastr.success('Conta a receber alterada com sucesso!');
          this.carregarContas();
          this.fecharModal();
        } else {
          this.toastr.error(response.errors[0]?.mensagem || 'Erro ao alterar conta a receber');
        }
      }, error => {
        this.toastr.error('Erro de conexão ao alterar conta a receber');
      });
    } else {
      this.financeiroService.salvarContaAReceber(this.novaConta).subscribe(response => {
        if (response.sucesso) {
          this.toastr.success('Conta a receber salva com sucesso!');
          this.carregarContas();
          this.fecharModal();
        } else {
          this.toastr.error(response.errors[0]?.mensagem || 'Erro ao salvar conta a receber');
        }
      }, error => {
        this.toastr.error('Erro de conexão ao salvar conta a receber');
      });
    }
  }

  receberConta(conta: any) {
    this.recebimento = {
      dataPagamento: new Date().toISOString().split('T')[0],
      valor: conta.valor,
      conta: conta
    };
    this.modalReceberConta = true;
  }

  confirmarRecebimento() {
    if (!this.recebimento.conta) return;

    const request: BaixarConta = {
      usuario: this.authService.AccessToken?.nome || '',
      contaId: this.recebimento.conta.id,
      valor: this.recebimento.valor,
      data: new Date(this.recebimento.dataPagamento).toISOString()
    };

    this.financeiroService.baixarContaAReceber(request).subscribe(response => {
      if (response.sucesso) {
        if (response.errors && response.errors.length > 0) {
          this.toastr.error(response.errors[0]?.mensagem || 'Erro ao realizar recebimento');
        } else {
          this.toastr.success('Recebimento realizado com sucesso!');
          this.carregarContas();
          this.fecharModal();
        }
      } else {
        this.toastr.error(response.errors[0]?.mensagem || 'Erro ao realizar recebimento');
      }
    }, error => {
      this.toastr.error('Erro de conexão ao realizar recebimento');
    });
  }

  alterarConta(conta: any) {
    this.financeiroService.obterContaPorId(conta.id).subscribe(response => {
      if (response.sucesso) {
        this.novaConta = {
          ...response.dados,
          dataVencimento: response.dados.dataVencimento ? response.dados.dataVencimento.split('T')[0] : ''
        };
        this.modalNovaConta = true;
      } else {
        this.toastr.error('Erro ao buscar detalhes da conta');
      }
    });
  }

  deletarConta(conta: any) {
    this.contaParaDeletar = conta;
    this.modalDeletarConta = true;
  }

  confirmarDelecao() {
    if (!this.contaParaDeletar) return;

    this.financeiroService.deletarConta(this.contaParaDeletar.id).subscribe(response => {
      if (response.sucesso) {
        this.toastr.success('Conta deletada com sucesso!');
        this.carregarContas();
        this.fecharModal();
      } else {
        this.toastr.error(response.errors[0]?.mensagem || 'Erro ao deletar conta');
      }
    }, error => {
      this.toastr.error('Erro de conexão ao deletar conta');
    });
  }
}
